export enum registrationStatus {
  DEFAULT = "",
  INCOMPLETE = "Incomplete",
  CONFIRMED = "Confirmed",
  ATTENDED = "Attended",
  NO_SHOW = "No show",
  CHECKED_OUT = "Checked out",
  CANCELLED = "Cancelled",
}

// CSV Attendee model according to the CSV template
interface CSVAttendee {
  fielddriveID: string;
  thirdPartyID: string;
  category: string;
  firstName?: string;
  lastName?: string;
  email: string;
  company: string;
  jobTitle: string;
  country: string;
  registrationStatus: registrationStatus;
  checkinDate: string;
  kioskName: string;
  operator: string;
  location: string;
  barcode: string;
  checkinMode: string;
}

// Attendee fieldValues
interface fieldValues {
  fname: string;
  lname: string;
  prefix: string;
  title: string;
  verifyemail: string;
  email: string;
  country: string;
  company: string;
  city: string;
}


export interface IAttendeeCheckHistory {
  id: number,
  checkAt: string,
  operator: string,
  location: string,
  device: string,
  createdAt: string,
  checkinMode: string,
  type: {
    id: number,
    name: string
  }
}

export interface ISessionScan {
  id: number,
  sessionReservationId: number,
  scanAt: string,
  type: string,
  createdAt: string
}

export interface ISessionReservation {
  id: number,
  eventSessionId: number,
  eventSessionThirdPartyId: string,
  accessAmount: number,
  message: string,
  amount: number
}

export default interface IAttendee extends CSVAttendee {
  id: number;
  name?: string;
  firstName?: string;
  lastName?: string;
  jobTitle: string;
  company: string;
  imageUrl: string;
  fieldValues: fieldValues;
  attendeeCheckHistories?: IAttendeeCheckHistory[];
  scans?: ISessionScan[];
  reservations?: ISessionReservation[];
  createdAt?: string,
  barcodeBlocked?: boolean;
  checkinAt?: string;
  balanceDue: number;
  thirdPartyId: string;
}
export interface ICheckInAttendeeList {
  accessAmount: number;
  barcode: string;
  canCheckIn: boolean;
  checkedInToday: boolean;
  company: string;
  consumedAmount: number;
  fieldValue: string;
  id: number;
  name: string;
  sessionReservationId: number;
  thirdPartyId: string;
}